import { QuickViewActivityType } from '@models';

const ACTIVITY_ICONS: Record<QuickViewActivityType, string> = {
  PatientMessaged: 'messages-outline',
  PatientDocumentUploaded: 'upload-outline',
  InvoiceCreated: 'file-circle-plus-outline',
  InvoiceSent: 'paper-plane-outline',
  PaymentPending: 'bank-payment',
  PaymentReceived: 'bank-payment',
};

export function activityIconOf(type: QuickViewActivityType): string {
  return ACTIVITY_ICONS[type] ?? 'clock';
}

export function activityTimeFormat(sameDay: boolean): string {
  return sameDay ? "'Today', h:mm a" : 'MMM d';
}
